import { getModalByTemplate, selectModal } from "../modal";

export function modalOpenPdfPageflip() {
  document.querySelectorAll("[data-action=heyzine]").forEach(card => {
    card.addEventListener("click", function (option) {
      getModalByTemplate("heyzine", { url: option.currentTarget.dataset.url })
    })
  })
}

if (document.querySelector("[data-action=heyzine]")) {
  modalOpenPdfPageflip();
}

export function modalOpenBtnPodcast() {
  document.querySelectorAll("[data-action=modal-podcast]").forEach(card => {
    card.addEventListener("click", function (option) {
      getModalByTemplate("podcast", { slug: option.currentTarget.dataset.slug });
    })
  });
}

if (document.querySelector("[data-action=modal-podcast]")) {
  modalOpenBtnPodcast();
}

export function modalOpenBtnGallery() {
  document.querySelectorAll("[data-action=modal-gallery]").forEach(card => {
    card.addEventListener("click", function (option) {
      getModalByTemplate("gallery", { slug: option.currentTarget.dataset.slug });
      selectModal("gallery");
    })
  });
}

if (document.querySelector("[data-action=modal-gallery]")) {
  modalOpenBtnGallery();
}

